import type { GraphqlConnection } from '@/types/graphql'
import type { GraphqlVarietyPack } from '@/types/shopify'

export interface GetVarietyPacksQuery {
  varietyPacks: GraphqlConnection<GraphqlVarietyPack>
}

export const getVarietyPacks = `query ($handle: String!, $locale: LanguageCode!) @inContext(country: US, language: $locale) {
	collection(handle: $handle) {
		id
		products(first: 10) {
			edges {
				node {
					id
					title
          handle
          tags
          description: descriptionHtml
          publishedAt
          createdAt
          updatedAt
          seo {
            title
            description
          }
          variants(first: 1) {
            edges {
              node {
                id
                sku
              }
            }
          }
          featuredImage {
            id
            width
            height
            url
            altText
          }
          ratingAverage: metafield(namespace: "flavor", key: "junip_rating_average") {
            value
          }
          ratingCount: metafield(namespace: "flavor", key: "junip_rating_count") {
            value
          }
          flavors: metafield(namespace: "flavor", key: "variety_pack_contents") {
            references(first: 16) {
              edges {
                node {
                  ... on Product {
                    id
                    title
                    shortTitle: metafield(namespace: "descriptors", key: "short_title") {
                      value
                    }
                  }
                }
              }
            }
          }
          skuMap: metafield(namespace: "flavor", key: "variety_pack_sku_mapping") {
            value
          }
          quantityMap: metafield(namespace: "flavor", key: "variety_pack_quantity_map") {
            value
          }
          flavorForwardImage: metafield(namespace: "flavor", key: "flavor_forward_image") {
            value
            reference {
              ... on MediaImage {
                image {
                  id
                  width
                  height
                  url
                  altText
                }
              }
            }
          }
        }
			}
		}
	}
}`
